var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slowenisch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.41824 12.4184,16 8,16 C3.58168,16 0,12.41824 0,8 C0,3.58168 3.58168,0 8,0 C12.4184,0 16,3.58168 16,8 L16,8 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags-/Slowenien",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1023",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-1020",
    fill: "#D8D8D8",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_Slovenia",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF0000",
    fillRule: "nonzero",
    points: "0 0 32 0 32 16 0 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0000FF",
    fillRule: "nonzero",
    points: "0 0 32 0 32 10.6666667 0 10.6666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "0 0 32 0 32 5.33333333 0 5.33333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5.938646, 2.805573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06057282,0 C2.02476615,5.68561011e-05 1.98905549,0.000790189442 1.95343735,0.00182298945 C1.26073868,0.0197781896 0.610410406,0.198661925 0.147343735,0.416822994 L0.147395735,0.41744806 C0.0967610677,0.438610727 0.0471618672,0.459826461 0,0.481041928 L0.159166668,2.97411475 C0.269448003,4.27693103 1.11848241,5.03547557 2.06182295,5.33333344 C3.0051635,5.03547557 3.85414617,4.27693103 3.96442697,2.97411475 L4.12270831,0.488958461 C4.07545018,0.464496594 4.02589417,0.440784327 3.97531257,0.41744806 L3.97536457,0.416822994 C3.48866537,0.187528058 2.79517816,0.00128618945 2.06296882,0 C2.06242855,0 2.06189442,0 2.06135415,0 C2.06109282,0 2.06083415,0 2.06057282,0 L2.06057282,0 Z",
    id: "Path",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06177147,1.7251871 L1.59615961,2.63441877 L1.29514445,2.24337357 L0.508586914,3.28283908 C0.522802035,3.34736209 0.53949629,3.40964441 0.557724954,3.4704583 C0.645572096,3.61871595 0.814383381,3.78796779 1.0308963,3.78796779 C1.2027092,3.78796779 1.37452154,3.65051792 1.54633388,3.65051781 C1.71814679,3.65051781 1.88995913,3.78796779 2.06177147,3.78796779 C2.23358381,3.78796779 2.40539615,3.65051792 2.57720905,3.65051781 C2.7490214,3.65051781 2.92083374,3.78796779 3.09264664,3.78796779 C3.30720291,3.78796779 3.47488914,3.6218611 3.56341277,3.47458183 C3.58230728,3.41213794 3.59927873,3.34782146 3.61392562,3.28146455 L2.82839849,2.24337357 L2.52738333,2.63441877 L2.06177147,1.7251871 Z M1.54633388,3.78796779 C1.37452154,3.78796779 1.2027092,3.92541789 1.0308963,3.92541778 C0.894917441,3.92541778 0.778104134,3.8772575 0.687615457,3.80892888 C0.719570359,3.87674969 0.753372152,3.94270928 0.790359244,4.00513877 C0.861241649,4.04921393 0.941798669,4.07901814 1.0308963,4.07901814 C1.2027092,4.07901814 1.37452154,3.94156805 1.54633388,3.94156816 C1.71814679,3.94156816 1.88995913,4.07901814 2.06177147,4.07901814 C2.23358381,4.07901814 2.40539615,3.94156805 2.57720905,3.94156816 C2.7490214,3.94156816 2.92083374,4.07901814 3.09264664,4.07901814 C3.18048706,4.07901814 3.25992128,4.04987838 3.33009136,4.00685686 C3.36706165,3.94462942 3.40083992,3.87889658 3.43283514,3.81133426 C3.34277543,3.87838669 3.22704125,3.92541778 3.09264664,3.92541778 C2.92083374,3.92541778 2.7490214,3.78796779 2.57720905,3.78796779 C2.40539615,3.78796779 2.23358381,3.92541789 2.06177147,3.92541778 C1.88995913,3.92541778 1.71814679,3.78796779 1.54633388,3.78796779 L1.54633388,3.78796779 Z M1.54633388,4.07901814 C1.37452154,4.07901814 1.2027092,4.21646835 1.0308963,4.21646813 C0.993568165,4.21646813 0.958071242,4.21209562 0.923685366,4.20547213 C1.22093002,4.60257477 1.6264625,4.86838426 2.06142763,5.02123775 C2.49549507,4.8686361 2.90038634,4.6026367 3.1974518,4.20615937 C3.16382361,4.212479 3.12907205,4.21646813 3.09264664,4.21646813 C2.92083374,4.21646813 2.7490214,4.07901814 2.57720905,4.07901814 C2.40539615,4.07901814 2.23358381,4.21646835 2.06177147,4.21646813 C1.88995913,4.21646813 1.71814679,4.07901814 1.54633388,4.07901814 L1.54633388,4.07901814 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(1.286690, 0.221048)",
    fill: "#FFFF00"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "b",
    points: "0 0.500111982 1.99991381 0.500111982 0.999956903 2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b-link",
    transform: "translate(1.000086, 1.000000) scale(-1, 1) rotate(-180.000000) translate(-1.000086, -1.000000) translate(0.000086, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "b",
    points: "0 0 2 0 1 2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.866870, 0.221048)",
    fill: "#FFFF00",
    id: "a-link"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.196227, 0.000000)",
    id: "a"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "b",
    points: "0 0.500111982 1.99991381 0.500111982 0.999956903 2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b-link",
    transform: "translate(1.000086, 1.000000) scale(-1, 1) rotate(-180.000000) translate(-1.000086, -1.000000) translate(0.000086, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "b",
    points: "0 0 2 0 1 2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.266427)",
    id: "a"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "b",
    points: "0 0.500111982 1.99991381 0.500111982 0.999956903 2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b-link",
    transform: "translate(1.000086, 1.000000) scale(-1, 1) rotate(-180.000000) translate(-1.000086, -1.000000) translate(0.000086, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "b",
    points: "0 0 2 0 1 2"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M8.15546827,2.91689573 C8.06631506,2.91742907 7.97746797,2.92518907 7.8888016,2.93617573 C7.97746797,2.9263624 8.0662739,2.91745573 8.15546827,2.91689573 Z M6.08609307,3.22301973 C6.03544267,3.24418853 5.98587307,3.265392 5.93869733,3.28661333 L6.097864,5.7797384 C6.20814533,7.08255461 7.05712773,7.84104723 8.00046827,8.13890509 C8.9438088,7.84104723 9.79279147,7.08255461 9.90307227,5.7797384 L10.0613536,3.29453013 C10.0140928,3.27006667 9.9645424,3.24635707 9.91395787,3.22301973 L9.76624933,5.6971864 C9.66387307,6.96384117 8.8757744,7.70129384 8.00005147,7.99088424 C7.12432853,7.70129384 6.33617787,6.96384117 6.2338016,5.6971864 L6.08609307,3.22301973 Z",
    id: "Shape",
    fill: "#FF0000",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl);
export default __webpack_public_path__ + "static/media/sl.9e2515895de1c68007c35cf28dd37c5f.svg";
export { ForwardRef as ReactComponent };